import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "./notification.hook";
import DevelopmentAreaService from "../services/api/developmentArea/DevelopmentArea.service";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../constants/Dictionary";
import { useEffect } from "react";
import { UpdateDevelopmentAreaBody } from "../types/api/developmentArea.type";
import { RefreshReactQuery } from "../constants/AppConstants";

export const useUpdateAreaDevelopment = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: UpdateDevelopmentAreaBody) =>
      DevelopmentAreaService.update(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-area-development"] });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore update development area ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, isPending };
};

export const useAreaDevelopment = () => {
  const { notification } = useNotification();

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ["get-area-development"],
    queryFn: DevelopmentAreaService.get,
    staleTime: RefreshReactQuery.INFINITY,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading, isFetching };
};
